<a
  id="dashboard-documentation-section"
  [routerLink]="'documentacion'"
  title="Documentación"
  class="dashboard-card section-card"
  [ngClass]="{ disabled: status < minStatus.attachDocumentation || isRejected }"
>
  <div class="dashboard-card__header">
    <h3 class="h-title">{{ 'cocumentation_section_title' | translate }}</h3>
  </div>
  <div class="dashboard-card__body">
    <span class="ic ic-document"></span>

    @if (!httpError) {
      <div>
        <h4 class="card-title">{{ 'cocumentation_section_msg' | translate }}</h4>

        @if (status == minStatus.attachDocumentation) {
          <div class="btn btn-02">
            {{ 'btn_continue_here' | translate }}
          </div>
        }
      </div>
    } @else {
      <p class="has-error">{{ 'cocumentation_section_msg_error' | translate }}</p>
    }
  </div>

  @if (status >= minStatus.attachDocumentation && !httpError) {
    <div class="dashboard-card__footer progress-container">
      <h4 class="pd-b-10">{{ 'cocumentation_section_domuments_validate' | translate }}</h4>
      <span class="doc-percent">{{ documentState?.percentage | number: '1.0-0' }} %</span>
      <div class="doc-progress"></div>
      <div class="progress-done" [style.width.%]="documentState?.percentage"></div>
    </div>
  }
</a>
